import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.coursesShowRecommend__swiper')) {
    new Swiper('.coursesShowRecommend__swiper', {
      slidesPerView: 1,
      loop: true,
      autoplay: false,
      speed: 3000,
      disableOnInteraction: false,
      navigation: {
        nextEl: '.coursesShowRecommend__swiperNext',
        prevEl: '.coursesShowRecommend__swiperPrev',
      },
    });
  }
});
